import { render, staticRenderFns } from "./PrescriptionOrderToday.vue?vue&type=template&id=7dc2fe49&"
import script from "./PrescriptionOrderToday.vue?vue&type=script&lang=js&"
export * from "./PrescriptionOrderToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports